import { SHOW_MESSAGE, CLOSE_MESSAGE, UPDATE_DATE, CHECK_EXTRACTOPT, CHECK_PUBLISHOPT } from '../actions/constants'

export default function messageBox(state = {}, action)
{
    switch (action.type){
        case SHOW_MESSAGE:
            return {
                ...state,
                ...action.messageBox
            }
        case CLOSE_MESSAGE:
            return {
                ...state,
                ...action.messageBox
            }
        case UPDATE_DATE: 
            return {
                ...state,
                ...action.messageBox
            }
        case CHECK_EXTRACTOPT: 
            return {
                ...state,
                ...action.messageBox
            }
        case CHECK_PUBLISHOPT: 
            return {
                ...state,
                ...action.messageBox
            }
        default:
            return state
    }
}


// WEBPACK FOOTER //
// ./src/reducers/messageBox.js